module.exports = {"classes":["psaas-page","header-dark"],"title":"PSaaS Terms","metas":{"description":"This page displays Auth0's PSaaS Terms, for use by Auth0 customers who subscribe to Auth0's private instance services."},"opengraph":{"og:title":"PSaaS Terms","og:description":"This page displays Auth0's PSaaS Terms, for use by Auth0 customers who subscribe to Auth0's private instance services.","og:url":"https://auth0.com/legal/baseline/psaas"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/psaas/metadata.json
// module id = 1537
// module chunks = 0